import { useEffect, useState } from "react";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function PrazosCliente() {
  const [prazos, setPrazos] = useState([]);

  useEffect(() => {
    api.get("/cliente_prazos.php")
      .then(r => setPrazos(r.data));
  }, []);

  return (
    <AppLayout
      title="Seus prazos"
      subtitle="Acompanhe datas importantes do seu processo"
    >
      <div className="space-y-4">
        {prazos.map((p, i) => (
          <div
            key={i}
            className="rounded-xl border border-[#1f2937] bg-[#121826] p-4"
          >
            <p className="font-medium text-slate-100">{p.descricao}</p>
            <p className="mt-1 text-sm text-slate-400">
              Data: {p.data_prazo}
            </p>
          </div>
        ))}

        {prazos.length === 0 && (
          <p className="text-slate-400">
            No momento, não há prazos ativos.
          </p>
        )}
      </div>
    </AppLayout>
  );
}
